export type FinanceInvoiceStatus = "draft" | "sent" | "partial" | "paid" | "void";

export type FinancePaymentMethod =
  | "cash"
  | "check"
  | "bank_transfer"
  | "card"
  | "ach"
  | "other";

export type FinanceCustomer = {
  id: string;
  name?: string;
  email?: string | null;
  phone?: string | null;
  companyName?: string | null;
  address?: string | null;
  currency?: string | null;
};

export type FinanceVendor = {
  id: string;
  name?: string;
  email?: string | null;
  phone?: string | null;
};

export type FinanceInvoiceLine = {
  description: string;
  quantity: number;
  unitPrice: number;
  amount: number;
  discountValue?: number | null;
  discountType?: "percent" | "amount" | string | null;
  taxRate?: number | null;
};

export type FinanceInvoice = {
  id: string;
  number?: string;
  customerId?: string | null;
  customerName?: string | null;
  status?: FinanceInvoiceStatus | string;
  amount?: number;
  amountPaid?: number;
  currency?: string;
  issueDate?: string | null;
  dueDate?: string | null;
  paymentTerms?: string | null;
  orderNumber?: string | null;
  subject?: string | null;
  customerNotes?: string | null;
  termsAndConditions?: string | null;
  billingAddressText?: string | null;
  shippingAddressText?: string | null;
  billToEmail?: string | null;
  billToUseAccountEmail?: boolean | null;
  billToContactId?: string | null;
  ccContactIds?: string[] | null;
  discountAmount?: number | null;
  discountLabel?: string | null;
  taxRate?: number | null;
  shippingCharges?: number | null;
  lateFee?: number | null;
  lines?: FinanceInvoiceLine[];
};

export type FinancePayment = {
  id: string;
  invoiceId: string;
  invoiceNumber?: string | null;
  customerName?: string | null;
  amount: number;
  currency?: string;
  paymentDate?: string | null;
  method?: FinancePaymentMethod | string | null;
  reference?: string | null;
};

export type FinanceSummary = {
  invoiceCount?: number;
  paidTotal?: number;
  openTotal?: number;
  overdueCount?: number;
  customerCount?: number;
  vendorCount?: number;
};

export const FINANCE_PAYMENT_METHODS: { value: FinancePaymentMethod; label: string }[] = [
  { value: "bank_transfer", label: "Bank transfer" },
  { value: "card", label: "Card" },
  { value: "check", label: "Check" },
  { value: "cash", label: "Cash" },
  { value: "ach", label: "ACH" },
  { value: "other", label: "Other" },
];
